enum RestParamsEnum {
    SELECTED_VALUES = 'selectedValues',
    NOTHING_SUBSTITUTION_VALUE= '~NOTHING~'
}

export default RestParamsEnum;
